import React from "react";
import { SocialMentionsContainer } from "./styles";
import AreaGraphCard from "../AreaGraphCard";
import { DurationOptions } from "../DurationSelector/constants";
import DashboardService from "../../../../../../services/Dashboard";
function SocialMentions({duration,selectedStock}) {

  const [mentions, setMentions] = React.useState(false);
  React.useEffect(() => {
    if(!selectedStock){
      return;
    }
    setMentions(false);
    DashboardService.getMentionsGraphData(selectedStock.nasdaq,DurationOptions[duration].timeRange).then((data) => {
      setMentions(data);
    }).catch(e=>{
      if(e?.response?.data){
        setMentions(e.response.data.message || e.response.data.detail);
      }
      else{
        setMentions(e.message || "Failed to load mentions data.");
      }
    });;
  }, [duration, selectedStock]);
  return (
    <SocialMentionsContainer>
      <AreaGraphCard
        title={"Social Mentions"}
        selectedStock={selectedStock}
        data={mentions}
        duration={duration}
        yLabel={"Mentions"}
        unit={"mention"}
        formatter={(value)=>value.toFixed(0)}
      />
    </SocialMentionsContainer>
  );
}
export default SocialMentions;